import Order, { emptyOrder } from '@/models/order'
import OrderProduct from '@/models/orderProduct'
import RetailerPage from '@/models/retailerPage'
import { getRetailerPage } from '@/utils/customerApi'
import { TrackPayload } from '@/utils/track'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

@Module({ name: 'customer', namespaced: true })
export default class extends VuexModule {
  locale = "ua"
  productsPerPage: number = 20
  categoriesPerPage: number = 20
  productsDisplayMode: string = "gallery"
  retailerPage: RetailerPage | null = null
  order: Order = emptyOrder()
  products: Array<OrderProduct> = []
  // Покупка, которую засчитаем на странице заказа, когда он подтвердится:
  // оплата картой сначала уводит на кассу, и до её ответа это ещё не продажа.
  // Хранится вместе с корзиной, поэтому переживает уход на кассу и возврат
  pendingPurchase: { orderId: number, payload: TrackPayload } | null = null

  // «Товаров и категорий в ряд на телефоне» → ширина колонки для b-col; null —
  // класса нет, по одной карточке в ряд, как было до настройки
  get mobileCols() {
    var columns = this.retailerPage ? this.retailerPage.mobileColumns : 1
    return columns > 1 ? 12 / columns : null
  }

  @Mutation
  setPendingPurchase(purchase: { orderId: number, payload: TrackPayload } | null) {
    this.pendingPurchase = purchase
  }

  @Mutation
  setOrder(order: Order) {
    this.order = order
  }

  @Mutation
  setProducts(products: Array<OrderProduct>) {
    this.products = products
  }

  @Mutation
  changeLocale(locale: string) {
    this.locale = locale
  }

  @Mutation
  setProductsPerPage(perPage: number) {
    this.productsPerPage = perPage
  }

  @Mutation
  setRetailerPage(retailerPage: RetailerPage) {
    this.retailerPage = retailerPage
  }

  @Mutation
  setProductsDisplayMode(value: string) {
    if (['gallery', 'table'].includes(value))
      this.productsDisplayMode = value
  }

  @Mutation
  setCategoriesPerPage(perPage: number) {
    this.categoriesPerPage = perPage
  }

  @Mutation
  clearProducts() {
    this.products = []
  }

  // @Action({commit: 'setRetailerPage'})
  @Action
  async getRetailerPage(publicUrl: string) {
    let retailerPage = await getRetailerPage(publicUrl)
    if (this.retailerPage && this.retailerPage.publicUrl != retailerPage.publicUrl) {
      this.setProducts([])
    }
    this.setRetailerPage(retailerPage)
  }
}

